import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { shareWhatsApp } from "@/lib/whatsapp";
import { Star, Clock, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

export const PackageCard = ({ pkg, index = 0, onBook }) => {
  const { t, lang, money } = useApp();
  const share = () => {
    const msg = lang === "ar"
      ? `🌟 ${pkg.name_ar}\n${pkg.desc_ar}\n⏱ ${pkg.duration_ar}\n💰 ${money(pkg.price)}\nاحجز الآن مع سفير بغداد`
      : `🌟 ${pkg.name_en}\n${pkg.desc_en}\n⏱ ${pkg.duration_en}\n💰 ${money(pkg.price)}\nBook now with Safeer Baghdad`;
    shareWhatsApp(msg);
  };
  return (
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      data-testid={`package-card-${pkg.id}`}
      className="card-hover bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm flex flex-col">
      <div className="relative h-52 overflow-hidden">
        <img src={pkg.image} alt={pkg[`name_${lang}`]} className="w-full h-full object-cover" />
        <span className="absolute top-3 start-3 bg-gold text-white text-xs font-bold px-3 py-1 rounded-full">
          {t.categories[pkg.category === "domestic" ? "domestic" : pkg.category === "international" ? "international" : pkg.category === "religious" ? "religious" : "leisure"]}
        </span>
        <span className="absolute top-3 end-3 bg-white/90 text-tigris text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
          <Star size={12} className="fill-gold text-gold" /> {pkg.rating}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-lg text-slate-800 mb-1.5 line-clamp-1">{pkg[`name_${lang}`]}</h3>
        <p className="text-sm text-slate-500 line-clamp-2 mb-3 flex-1">{pkg[`desc_${lang}`]}</p>
        <div className="flex items-center gap-1.5 text-xs text-slate-400 mb-4">
          <Clock size={14} /> {pkg[`duration_${lang}`]}
        </div>
        <div className="flex items-center justify-between mb-3">
          <div>
            <span className="text-xs text-slate-400">{t.common.from}</span>
            <div className="text-xl font-extrabold text-tigris">{money(pkg.price)}</div>
          </div>
        </div>
        <div className="flex gap-2">
          <button data-testid={`book-package-${pkg.id}`} onClick={() => onBook(pkg)} className="btn-primary flex-1 py-2.5 rounded-xl font-bold text-sm">
            {t.common.bookNow}
          </button>
          <button data-testid={`share-package-${pkg.id}`} onClick={share} className="btn-wa w-11 rounded-xl flex items-center justify-center" title={t.common.shareWhatsapp}>
            <MessageCircle size={18} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export const PackagesSection = ({ onBook }) => {
  const { t } = useApp();
  const [packages, setPackages] = useState([]);
  useEffect(() => { api.get("/packages").then((r) => setPackages(r.data)); }, []);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-12">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-800 mb-3">{t.sections.pkgTitle}</h2>
        <p className="text-slate-500 max-w-2xl mx-auto">{t.sections.pkgSub}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {packages.map((p, i) => <PackageCard key={p.id} pkg={p} index={i} onBook={onBook} />)}
      </div>
    </section>
  );
};
